export default "__VITE_ASSET__B37MO_Gg__"